export const marketMakingFeatures = [
  {
    img: require("../../../image/Marketmaking/fe_img_one.webp"),
    title: "Suitable Bid-Ask Orders on the New Platform",
    desc: "Our crypto market-making bot retrieves orders from major third-party exchanges and populates the order books of your new digital asset exchange with suitable orders, ensuring organic liquidity",
  },
  {
    img: require("../../../image/Marketmaking/fe_img_two.webp"),
    title: "Quick Adaptability",
    desc: "With our market-making bots, you can adapt your trading approach to changing market circumstances and expand your list of liquidity providers at any moment via an easily programmable API",
  },
  {
    img: require("../../../image/Marketmaking/fe_img_three.webp"),
    title: "Automatic Cryptocurrency Trading",
    desc: "Use our amazing bot on your controlled or decentralized cryptocurrency exchange to implement any pre-built or built-in crypto market-making plan",
  },
  {
    img: require("../../../image/Marketmaking/fe_img_four.webp"),
    title: "24/7 Trading",
    desc: "With a single button press, our market-creating crypto bot allows digital asset trading routes to execute the most sophisticated tactics 24/7 a day",
  },
  {
    img: require("../../../image/Marketmaking/fe_img_five.webp"),
    title: "Transparent Market Making",
    desc: "Instead of using black-box market makers, use an adaptive crypto market maker that gives you total control over market-making activities",
  },
  {
    img: require("../../../image/Marketmaking/fe_img_six.webp"),
    title: "Order Book Aggregation",
    desc: "Our APIs allow crypto exchanges to connect bid and ask orders on their platform with those on third-party trading platforms and liquidity providers, allowing investors to buy at the best price",
  },
  {
    img: require("../../../image/Marketmaking/fe_img_seven.webp"),
    title: "Automated Market Maker technology with less lag",
    desc: "Our Automated Market Maker software crypto allows high-frequency trading, which assists in the development of stable markets",
  },
  {
    img: require("../../../image/Marketmaking/fe_img_eight.webp"),
    title: "Real-time data access",
    desc: "Examine and analyze the efficacy of your market-making plan bitcoin using our market-making bot, which efficiently captures data",
  },
  {
    img: require("../../../image/Marketmaking/fe_img_nine.webp"),
    title: "Risk Management",
    desc: "Using precisely designed risk management tools and algorithms, our market-maker crypto exchange enables you to control risks simply and efficiently",
  },
];
